/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCornerUpRight = createReactComponent("corner-up-right", "IconCornerUpRight", [
  ["path", { d: "M6 18v-6a3 3 0 0 1 3 -3h10l-4 -4m0 8l4 -4", key: "svg-0" }]
]);

export { IconCornerUpRight as default };
//# sourceMappingURL=IconCornerUpRight.js.map
